import React, { FC } from "react";
import { Calendar } from "./Calendar";

export const CalendarContainer: FC = () => {
    return (
        <Calendar />
    );
}